/**
 * Cars Shop - Global JavaScript
 * Matches original Next.js functionality
 */

document.addEventListener('DOMContentLoaded', function() {
  // Mobile menu functionality
  initMobileMenu();
  
  // Cart functionality
  initCart();
  
  // Wishlist functionality
  initWishlist();
  
  // Quantity selectors
  initQuantitySelectors();
  
  // Smooth scroll for anchor links
  initSmoothScroll();
  
  // Lazy loading images
  initLazyLoading();
});

/**
 * Mobile Menu
 */
function initMobileMenu() {
  const mobileMenu = document.getElementById('mobile-menu');
  const mobileOverlay = document.getElementById('mobile-overlay');
  const closeBtn = document.querySelector('.mobile-menu-close');

  if (!mobileMenu) return;

  // Close menu function
  function closeMenu() {
    mobileMenu.classList.remove('open');
    mobileOverlay?.classList.remove('open');
    document.body.style.overflow = '';
  }

  // Close button
  closeBtn?.addEventListener('click', closeMenu);

  // Overlay click
  mobileOverlay?.addEventListener('click', closeMenu);

  // Escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeMenu();
  });
}

/**
 * Cart Functionality
 */
function initCart() {
  // Add to cart forms
  document.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
    form.addEventListener('submit', async function(e) {
      e.preventDefault();
      
      const button = form.querySelector('button[type="submit"]');
      const originalText = button.innerHTML;
      
      button.disabled = true;
      button.innerHTML = '<span class="animate-spin">⟳</span>';
      
      try {
        const formData = new FormData(form);
        const variantId = formData.get('id');
        
        // Check if product is already in cart
        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();
        
        const isAlreadyInCart = cart.items.some(item => 
          String(item.variant_id) === String(variantId) || String(item.id) === String(variantId)
        );
        
        if (isAlreadyInCart) {
          showToast('Ten produkt już znajduje się w Twoim koszyku', 'warning');
          button.innerHTML = originalText;
          button.disabled = false;
          return;
        }
        
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });
        
        if (response.ok) {
          await updateCartCount();
          button.innerHTML = '✓ Dodano';
          showToast('Produkt dodany do koszyka', 'success');
          setTimeout(() => {
            button.innerHTML = originalText;
            button.disabled = false;
          }, 1500);
        } else {
          throw new Error('Failed to add to cart');
        }
      } catch (error) {
        console.error('Error:', error);
        button.innerHTML = 'Błąd';
        showToast('Wystąpił błąd podczas dodawania do koszyka', 'error');
        setTimeout(() => {
          button.innerHTML = originalText;
          button.disabled = false;
        }, 1500);
      }
    });
  });
}

/**
 * Update cart count in header
 */
async function updateCartCount() {
  try {
    const response = await fetch('/cart.js');
    const cart = await response.json();
    
    // Update all cart count elements
    document.querySelectorAll('.cart-count').forEach(el => {
      el.textContent = cart.item_count;
    });
    
    document.querySelectorAll('.cart-count-badge').forEach(el => {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? 'flex' : 'none';
    });
    
    document.querySelectorAll('.cart-total').forEach(el => {
      el.textContent = formatMoney(cart.total_price);
    });
  } catch (error) {
    console.error('Error updating cart:', error);
  }
}

/**
 * Format money helper
 */
function formatMoney(cents) {
  return (cents / 100).toFixed(2).replace('.', ',') + ' zł';
}

/**
 * Wishlist Functionality
 */
function initWishlist() {
  const STORAGE_KEY = 'cars_shop_wishlist';
  
  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch {
      return [];
    }
  }
  
  function saveWishlist(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    updateWishlistCount();
  }
  
  function updateWishlistCount() {
    const count = getWishlist().length;
    document.querySelectorAll('.wishlist-count').forEach(el => {
      el.textContent = count;
      el.classList.toggle('hidden', count === 0);
    });
  }
  
  // Initialize count
  updateWishlistCount();
  
  // Wishlist buttons
  document.querySelectorAll('.wishlist-btn').forEach(btn => {
    const productHandle = btn.dataset.productHandle || btn.dataset.productId;
    const wishlist = getWishlist();
    
    if (wishlist.includes(productHandle)) {
      btn.classList.add('active', 'text-red-500', 'border-red-500');
    }
    
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      const wishlist = getWishlist();
      const index = wishlist.indexOf(productHandle);
      
      if (index > -1) {
        wishlist.splice(index, 1);
        btn.classList.remove('active', 'text-red-500', 'border-red-500');
        showToast('Produkt usunięty z listy życzeń');
      } else {
        wishlist.push(productHandle);
        btn.classList.add('active', 'text-red-500', 'border-red-500');
        showToast('Produkt dodany do listy życzeń');
      }
      
      saveWishlist(wishlist);
    });
  });
}


/**
 * Quantity Selectors
 */
function initQuantitySelectors() {
  document.querySelectorAll('.quantity-selector').forEach(selector => {
    const minusBtn = selector.querySelector('.quantity-minus');
    const plusBtn = selector.querySelector('.quantity-plus');
    const input = selector.querySelector('.quantity-input');
    
    if (!input) return;
    
    const min = parseInt(input.min) || 1;
    const max = parseInt(input.max) || parseInt(selector.dataset.maxQuantity) || 999;
    
    // Update max from data attribute if available
    if (selector.dataset.maxQuantity) {
      input.max = selector.dataset.maxQuantity;
    }
    
    minusBtn?.addEventListener('click', function() {
      const current = parseInt(input.value) || min;
      if (current > min) {
        input.value = current - 1;
        input.dispatchEvent(new Event('change'));
        updateButtonStates();
      }
    });
    
    plusBtn?.addEventListener('click', function() {
      const current = parseInt(input.value) || min;
      const currentMax = parseInt(input.max) || max;
      if (current < currentMax) {
        input.value = current + 1;
        input.dispatchEvent(new Event('change'));
        updateButtonStates();
      }
    });
    
    // Prevent manual input exceeding max
    input.addEventListener('change', function() {
      const currentMax = parseInt(input.max) || max;
      let value = parseInt(input.value) || min;
      
      if (value < min) value = min;
      if (value > currentMax) value = currentMax;
      
      input.value = value;
      updateButtonStates();
    });
    
    function updateButtonStates() {
      const current = parseInt(input.value) || min;
      const currentMax = parseInt(input.max) || max;
      
      if (minusBtn) {
        minusBtn.disabled = current <= min;
        minusBtn.style.opacity = current <= min ? '0.5' : '1';
      }
      if (plusBtn) {
        plusBtn.disabled = current >= currentMax;
        plusBtn.style.opacity = current >= currentMax ? '0.5' : '1';
      }
    }
    
    updateButtonStates();
  });
}

/**
 * Smooth Scroll
 */
function initSmoothScroll() {
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      const targetId = this.getAttribute('href');
      if (targetId === '#') return;
      
      const target = document.querySelector(targetId);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth' });
      }
    });
  });
}

/**
 * Lazy Loading
 */
function initLazyLoading() {
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          if (img.dataset.src) {
            img.src = img.dataset.src;
            img.removeAttribute('data-src');
          }
          observer.unobserve(img);
        }
      });
    }, { rootMargin: '100px' });
    
    document.querySelectorAll('img[data-src]').forEach(img => {
      observer.observe(img);
    });
  }
}

/**
 * Toast Notification
 */
function showToast(message, type = 'success') {
  const toast = document.createElement('div');
  toast.className = `toast ${type}`;
  toast.textContent = message;
  document.body.appendChild(toast);
  
  setTimeout(() => toast.classList.add('show'), 100);
  
  setTimeout(() => {
    toast.classList.remove('show');
    setTimeout(() => toast.remove(), 300);
  }, 3000);
}

// Export for global use
window.CarsShop = {
  updateCartCount,
  showToast,
  formatMoney
};
